(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[31],{

/***/ "+o/G":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"pagingButton":"_3au2n_","default":"_1Lb9R6","firstButton":"_3V-Mfg","lastButton":"OTUgAO","dotButton":"_1PiYxC","active":"_2Voyyp"};

/***/ }),

/***/ "4XkN":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2WreiD","label":"_2hhvQw","hasValue":"_39FOXP","selectWrapper":"_2S7UN9","column":"_25M7ZT"};

/***/ }),

/***/ "5NJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./services/url-maker.js
var url_maker = __webpack_require__("JirP");

// EXTERNAL MODULE: ./src/helpers/url/index.js
var helpers_url = __webpack_require__("gjsy");

// EXTERNAL MODULE: ./src/utils/string-utils/index.js
var string_utils = __webpack_require__("KNqG");

// EXTERNAL MODULE: ./src/helpers/url-maker/index.js
var helpers_url_maker = __webpack_require__("fcgK");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/index.jsx + 4 modules
var suggestion_box = __webpack_require__("T/J1");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/shortid/index.js
var shortid = __webpack_require__("je4i");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/Popper/index.js
var Popper = __webpack_require__("0cs1");
var Popper_default = /*#__PURE__*/__webpack_require__.n(Popper);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/ClickAwayListener/index.js
var ClickAwayListener = __webpack_require__("+qgJ");
var ClickAwayListener_default = /*#__PURE__*/__webpack_require__.n(ClickAwayListener);

// CONCATENATED MODULE: ./__mock__/agentFilterDropdownList.js
var agentFilterDropdownList_filters = [{
  categoryKey: 'HOUSING',
  availableTradeTypes: [{
    id: 2,
    name: 'Satılık Konut',
    url: 'satilik-konut',
    tradeTypeId: 2,
    tradeTypeSlug: 'satilik',
    categorySlug: 'konut'
  }, {
    id: 2,
    name: 'Kiralık Konut',
    url: 'kiralik-konut',
    tradeTypeId: 6,
    tradeTypeSlug: 'kiralik',
    categorySlug: 'konut'
  }, {
    id: 2,
    name: 'Günlük Kiralık Konut',
    url: 'gunluk-kiralik-konut',
    tradeTypeId: 10,
    tradeTypeSlug: 'gunluk-kiralik',
    categorySlug: 'konut'
  }],
  label: 'Konut'
}, {
  categoryKey: 'WORKPLACE',
  availableTradeTypes: [{
    id: 3,
    name: 'Satılık İşyeri',
    url: 'satilik-isyeri',
    tradeTypeId: 3,
    tradeTypeSlug: 'satilik',
    categorySlug: 'isyeri'
  }, {
    id: 3,
    name: 'Kiralık İşyeri',
    url: 'kiralik-isyeri',
    tradeTypeId: 7,
    tradeTypeSlug: 'kiralik',
    categorySlug: 'isyeri'
  }, {
    id: 3,
    name: 'Devren İşyeri',
    url: 'devren-isyeri',
    tradeTypeId: 11,
    tradeTypeSlug: 'devren',
    categorySlug: 'isyeri'
  }],
  label: 'İşyeri'
}, {
  categoryKey: 'LAND',
  availableTradeTypes: [{
    id: 1,
    name: 'Satılık Arsa',
    url: 'satilik-arsa',
    tradeTypeId: 1,
    tradeTypeSlug: 'satilik',
    categorySlug: 'arsa'
  }, {
    id: 1,
    name: 'Kiralık Arsa',
    url: 'kiralik-arsa',
    tradeTypeId: 5,
    tradeTypeSlug: 'kiralik',
    categorySlug: 'arsa'
  }, {
    id: 1,
    name: 'Kat Karşılığı Arsa',
    url: 'kat-karsiligi-arsa',
    tradeTypeId: 9,
    tradeTypeSlug: 'kat-karsiligi',
    categorySlug: 'arsa'
  }],
  label: 'Arsa'
}, {
  categoryKey: 'TOURIST_FACILITY',
  availableTradeTypes: [{
    id: 6,
    name: 'Satılık Turistik Tesis',
    url: 'satilik-turistik-tesis',
    tradeTypeId: 4,
    tradeTypeSlug: 'satilik',
    categorySlug: 'turistik-tesis'
  }, {
    id: 6,
    name: 'Turistik Turistik Tesis',
    url: 'kiralik-turistik-tesis',
    tradeTypeId: 8,
    tradeTypeSlug: 'kiralik',
    categorySlug: 'turistik-tesis'
  }],
  label: 'Turistik Tesis'
}];
/* harmony default export */ var agentFilterDropdownList = (agentFilterDropdownList_filters);
// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/e6t/common-filters/filter-dropdown/styles.module.scss
var styles_module = __webpack_require__("4XkN");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/e6t/common-filters/filter-dropdown/index.jsx







var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






 // eslint-disable-next-line import/no-unresolved






var filter_dropdown_FilterDropdown = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FilterDropdown, _React$Component);

  var _super = _createSuper(FilterDropdown);

  function FilterDropdown() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FilterDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      anchorEl: null,
      open: false,
      filters: [],
      label: 'Satılık Konut'
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "createFilters", function () {
      return agentFilterDropdownList.map(function (category) {
        var item = {
          label: category.label,
          items: []
        };
        category.availableTradeTypes.map(function (filterItem) {
          var generatedCategory = {
            category: {
              id: filterItem.id,
              slug: filterItem.categorySlug
            },
            tradeType: {
              id: filterItem.tradeTypeId,
              slug: filterItem.tradeTypeSlug
            }
          };
          item.items.push({
            name: filterItem.name,
            category: generatedCategory
          });
        });
        return item;
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleClick", function (event) {
      var currentTarget = event.currentTarget;

      _this.setState(function (state) {
        return {
          anchorEl: currentTarget,
          open: !state.open
        };
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleClose", function () {
      _this.setState({
        open: false
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleFilterItemClick", function (e, category) {
      var _this$props$pageType = _this.props.pageType,
          pageType = _this$props$pageType === void 0 ? null : _this$props$pageType;
      e.preventDefault();
      var criteria = _this.props.criteria;

      var generatedCriteria = _objectSpread(_objectSpread({}, criteria), {}, {
        category: category
      });

      delete generatedCriteria.pagination; // THIS HELPER CREATED FOR NEW "URL MAKER" BE SERVICE REQUESTS

      var criteriaObject = Object(helpers_url_maker["a" /* getNewSuitableCriteria */])(generatedCriteria);
      Object(url_maker["a" /* urlMaker */])({
        criteria: criteriaObject
      }).then(function (res) {
        var url = Object(helpers_url["g" /* normalizeUrl */])(res.data.path);

        if (pageType === 'showcase') {
          var cleanUrl = url.startsWith('/') ? url.substring(1) : url;
          url = "/vitrin/".concat(cleanUrl);
        }

        window.location.href = url;
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(FilterDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _criteria$category, _criteria$category2;

      var criteria = this.props.criteria;
      var filters = this.createFilters();
      this.setState({
        filters: filters
      });

      if ((criteria === null || criteria === void 0 ? void 0 : (_criteria$category = criteria.category) === null || _criteria$category === void 0 ? void 0 : _criteria$category.category) && (criteria === null || criteria === void 0 ? void 0 : (_criteria$category2 = criteria.category) === null || _criteria$category2 === void 0 ? void 0 : _criteria$category2.tradeType)) {
        var label = "".concat(criteria.category.tradeType.name, " ").concat(criteria.category.category.name);
        this.setState({
          label: label
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$state = this.state,
          anchorEl = _this$state.anchorEl,
          open = _this$state.open,
          filters = _this$state.filters,
          label = _this$state.label;
      var labelClass = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, styles_module_default.a.label, true), Object(defineProperty["default"])(_classNames, styles_module_default.a.hasValue, open), _classNames));
      return __jsx("div", {
        className: styles_module_default.a.wrapper
      }, __jsx(desktop_elements["b" /* Button */], {
        disableRipple: true,
        fullWidth: true,
        transparent: true,
        tertiary: true,
        isOpen: open,
        onClick: this.handleClick
      }, __jsx("div", {
        className: labelClass
      }, label), __jsx(desktop_elements["e" /* Icon */], {
        name: open ? 'expand_less' : 'expand_more'
      })), __jsx(Popper_default.a, {
        open: open,
        anchorEl: anchorEl,
        placement: "bottom-start",
        style: {
          zIndex: 1
        }
      }, __jsx(ClickAwayListener_default.a, {
        onClickAway: this.handleClose
      }, __jsx("div", {
        className: styles_module_default.a.selectWrapper
      }, filters.length ? filters.map(function (filterColumn) {
        return __jsx("div", {
          className: styles_module_default.a.column,
          key: shortid_default.a.generate()
        }, __jsx("ul", null, __jsx("li", null, __jsx("strong", null, filterColumn.label)), filterColumn.items.length ? filterColumn.items.map(function (filterItem) {
          return __jsx("li", {
            key: shortid_default.a.generate()
          }, __jsx("a", {
            href: "!#",
            onClick: function onClick(e) {
              return _this2.handleFilterItemClick(e, filterItem.category);
            }
          }, filterItem.name));
        }) : null));
      }) : null))));
    }
  }]);

  return FilterDropdown;
}(react_default.a.Component);

/* harmony default export */ var filter_dropdown = (filter_dropdown_FilterDropdown);
// EXTERNAL MODULE: ./src/components/desktop/common/content/index.jsx
var content = __webpack_require__("LmzW");

// EXTERNAL MODULE: ./src/components/e6t/common-filters/filter-bar/styles.module.scss
var filter_bar_styles_module = __webpack_require__("Oe3A");
var filter_bar_styles_module_default = /*#__PURE__*/__webpack_require__.n(filter_bar_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/common-filters/filter-bar/index.jsx

var filter_bar_jsx = react_default.a.createElement;

function filter_bar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function filter_bar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { filter_bar_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { filter_bar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var filter_bar_FilterBar = function FilterBar(_ref) {
  var _classNames;

  var criteria = _ref.criteria,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? null : _ref$pageType,
      type = _ref.type;

  var _useState = Object(react["useState"])(false),
      isFocused = _useState[0],
      setIsFocused = _useState[1];

  var _useState2 = Object(react["useState"])(criteria || {}),
      criteriaState = _useState2[0],
      setCriteriaState = _useState2[1];

  var pageTitle = pageType === 'realEstate' ? 'Bu ofisin ilanlarını listele' : 'Vitrin İlanları';

  var onSearchLocationChanged = function onSearchLocationChanged(freeTextValue, location) {
    setCriteriaState(filter_bar_objectSpread(filter_bar_objectSpread({}, criteriaState), {}, {
      freetext: {
        value: freeTextValue
      },
      location: location
    }));
  };

  var onSearchWithKeyPress = function onSearchWithKeyPress(freeTextValue) {
    if (Object(string_utils["e" /* isNumber */])(freeTextValue)) {
      window.location.href = "/ilan/ilan-detay-".concat(freeTextValue);
    } else {
      setCriteriaState(filter_bar_objectSpread(filter_bar_objectSpread({}, criteriaState), {}, {
        freetext: {
          value: freeTextValue
        }
      }));
    }
  };

  var onTextChange = function onTextChange(freeTextValue) {
    setCriteriaState(filter_bar_objectSpread(filter_bar_objectSpread({}, criteriaState), {}, {
      freetext: {
        value: freeTextValue
      }
    }));
  };

  var prepareSearch = function prepareSearch() {
    if (criteriaState.location) {
      var searchGTMAction = Object(events["r" /* generateActionTextForSearchboxGTMEventE6t */])(null, criteriaState.location, '');
      var searchGTMLabel = Object(events["s" /* generateLabelTextForSearchboxGTMEventE6t */])(criteriaState.location, '');

      if (typeof searchGTMAction !== 'undefined' && typeof searchGTMLabel !== 'undefined') {
        Object(events["Q" /* searchGTMEvents */])({
          action: searchGTMAction,
          label: searchGTMLabel
        });
      }
    }

    if (!(criteriaState === null || criteriaState === void 0 ? void 0 : criteriaState.category)) {
      criteriaState.category = {
        category: {
          id: 2,
          name: 'Konut',
          slug: 'konut',
          oldId: null
        },
        estateTypes: [],
        tradeType: {
          id: 2,
          name: 'Satılık',
          slug: 'satilik',
          oldId: 1
        }
      };
    }

    delete criteriaState.pagination;
    delete criteriaState.params;
    delete criteriaState.locations; // THIS HELPER CREATED FOR NEW "URL MAKER" BE SERVICE REQUESTS
    // eslint-disable-next-line no-shadow

    var criteria = Object(helpers_url_maker["a" /* getNewSuitableCriteria */])(criteriaState);
    Object(url_maker["a" /* urlMaker */])({
      criteria: criteria
    }).then(function (res) {
      var url = Object(helpers_url["g" /* normalizeUrl */])(res.data.path);

      if (pageType === 'showcase') {
        var cleanUrl = url.startsWith('/') ? url.substring(1) : url;
        url = "/vitrin/".concat(cleanUrl);
      }

      window.location.href = url;
    });
  };

  var wrapperClasses = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, filter_bar_styles_module_default.a.pageWrapper, true), Object(defineProperty["default"])(_classNames, filter_bar_styles_module_default.a.pageWrapperPlatinum, type === 'platinum' || type === 'platinum plus'), _classNames));
  return filter_bar_jsx("div", {
    className: wrapperClasses
  }, filter_bar_jsx(content["a" /* default */], null, filter_bar_jsx("div", {
    className: filter_bar_styles_module_default.a.container
  }, filter_bar_jsx("div", {
    className: filter_bar_styles_module_default.a.title
  }, filter_bar_jsx("span", null, pageTitle)), filter_bar_jsx(filter_dropdown, {
    criteria: criteriaState,
    searchType: "listing",
    pageType: pageType
  }), filter_bar_jsx("div", {
    className: filter_bar_styles_module_default.a.suggestionBoxWrapper
  }, filter_bar_jsx(suggestion_box["a" /* default */], {
    filters: criteriaState,
    onLocationChange: onSearchLocationChanged,
    onSearchTriggered: onSearchWithKeyPress,
    onTextChange: onTextChange,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    searchType: "listing",
    placeholder: "\u0130l, il\xE7e, mahalle, proje, okul, metro\u2026"
  })), filter_bar_jsx(desktop_elements["b" /* Button */], {
    type: "submit",
    primary: true,
    onClick: prepareSearch
  }, "ARA"))));
};

/* harmony default export */ var filter_bar = __webpack_exports__["a"] = (filter_bar_FilterBar);

/***/ }),

/***/ "JirP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return urlMaker; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_axiosInstance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("g33+");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

function urlMaker(_ref) {
  var criteria = _ref.criteria;
  var url = "".concat(publicRuntimeConfig.urlMaker, "v1/url-maker/");
  return _config_axiosInstance__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].post(url, _objectSpread({}, criteria)).then(function (response) {
    return response;
  })["catch"](function (error) {
    return error.response.data;
  });
}

/***/ }),

/***/ "KNLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/helpers/url/index.js
var helpers_url = __webpack_require__("gjsy");

// EXTERNAL MODULE: ./node_modules/shortid/index.js
var shortid = __webpack_require__("je4i");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/components/desktop/listing/listing-paging/button/styles.module.scss
var styles_module = __webpack_require__("+o/G");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/listing-paging/button/index.jsx
var __jsx = react_default.a.createElement;



var button_PagingButton = function PagingButton(_ref) {
  var firstButton = _ref.firstButton,
      lastButton = _ref.lastButton,
      dotButton = _ref.dotButton,
      currentPage = _ref.currentPage,
      _onClick = _ref.onClick,
      child = _ref.child,
      value = _ref.value,
      dataEjCategory = _ref['data-ej-category'],
      dataEjAction = _ref['data-ej-action'],
      dataEjLabel = _ref['data-ej-label'];
  var classNames = [styles_module_default.a.pagingButton];
  var buttonClassName = null;

  if (firstButton) {
    buttonClassName = styles_module_default.a.firstButton;
  } else if (lastButton) {
    buttonClassName = styles_module_default.a.lastButton;
  } else if (dotButton) {
    buttonClassName = styles_module_default.a.dotButton;
  } else {
    buttonClassName = styles_module_default.a["default"];
  }

  classNames.push(buttonClassName);

  if (currentPage) {
    classNames.push(styles_module_default.a.active);
  }

  return __jsx("li", {
    className: classNames.join(' ')
  }, __jsx("div", {
    className: styles_module_default.a.pagingButton,
    onClick: function onClick() {
      return _onClick(value);
    },
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel,
    "data-test-selector": "listing-pagination-".concat(value)
  }, child));
};

/* harmony default export */ var listing_paging_button = (button_PagingButton);
// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/listing/pagination-e6t/styles.module.scss
var pagination_e6t_styles_module = __webpack_require__("TGiq");
var pagination_e6t_styles_module_default = /*#__PURE__*/__webpack_require__.n(pagination_e6t_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/pagination-e6t/index.jsx
var pagination_e6t_jsx = react_default.a.createElement;







var pagination_e6t_PaginationE6t = function PaginationE6t(props) {
  var _options;

  var url = props.url,
      totalPagination = props.totalPagination,
      options = props.options,
      defaultValue = props.defaultValue,
      styles = props.styles,
      prev = props.prev,
      next = props.next,
      isProjectPage = props.isProjectPage,
      dataEjCategory = props['data-ej-category'],
      dataEjAction = props['data-ej-action'],
      dataEjLabel = props['data-ej-label'],
      isShowcasePage = props.isShowcasePage;
  var currentPage = defaultValue.value;
  var showFirstItem = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) > 4;
  var showLastItem = Number((_options = options[options.length - 1]) === null || _options === void 0 ? void 0 : _options.label) < Number(totalPagination.label);
  return pagination_e6t_jsx("div", {
    className: pagination_e6t_styles_module_default.a.paginationContainer
  }, pagination_e6t_jsx("ul", {
    className: pagination_e6t_styles_module_default.a.pagination
  }, prev && pagination_e6t_jsx(listing_paging_button, {
    child: pagination_e6t_jsx("a", {
      href: Object(helpers_url["g" /* normalizeUrl */])(prev),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel).concat(currentPage - 1)
    }, pagination_e6t_jsx(desktop_elements["e" /* Icon */], {
      name: "navigate_before"
    }), ' Önceki'),
    firstButton: true,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel).concat(currentPage + 1)
  }), showFirstItem && pagination_e6t_jsx(react_default.a.Fragment, null, pagination_e6t_jsx(listing_paging_button, {
    key: shortid_default.a.generate(),
    child: pagination_e6t_jsx("a", {
      href: Object(helpers_url["a" /* createPaginationUrl */])({
        url: url,
        page: 1,
        isProjectPage: isProjectPage,
        isShowcasePage: isShowcasePage
      }),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel, 1)
    }, 1),
    value: 1,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, 1)
  }), pagination_e6t_jsx(listing_paging_button, {
    dotButton: true,
    child: pagination_e6t_jsx("span", null, "..."),
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, "dot")
  })), options.map(function (pageItem) {
    var pageNumber = pageItem.value;
    var hrefValue = Object(helpers_url["a" /* createPaginationUrl */])({
      url: url,
      page: pageNumber,
      isProjectPage: isProjectPage,
      isShowcasePage: isShowcasePage
    });
    return pagination_e6t_jsx(listing_paging_button, {
      key: shortid_default.a.generate(),
      child: pagination_e6t_jsx("a", {
        href: hrefValue,
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": "".concat(dataEjLabel).concat(pageNumber)
      }, pageNumber),
      value: pageNumber,
      currentPage: pageNumber === currentPage,
      onClick: function onClick() {},
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel).concat(pageNumber)
    });
  }), showLastItem && pagination_e6t_jsx(react_default.a.Fragment, null, pagination_e6t_jsx(listing_paging_button, {
    dotButton: true,
    child: pagination_e6t_jsx("span", null, "..."),
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, "dot")
  }), pagination_e6t_jsx(listing_paging_button, {
    key: shortid_default.a.generate(),
    child: pagination_e6t_jsx("a", {
      href: Object(helpers_url["g" /* normalizeUrl */])(totalPagination.url),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel).concat(totalPagination.label)
    }, totalPagination.label),
    value: totalPagination.label,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, 1)
  })), next && pagination_e6t_jsx(listing_paging_button, {
    child: pagination_e6t_jsx("a", {
      href: Object(helpers_url["g" /* normalizeUrl */])(next),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel).concat(currentPage + 1)
    }, 'Sonraki ', pagination_e6t_jsx(desktop_elements["e" /* Icon */], {
      name: "navigate_next"
    })),
    lastButton: true,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel).concat(currentPage + 1)
  })));
};

/* harmony default export */ var pagination_e6t = (pagination_e6t_PaginationE6t);
// EXTERNAL MODULE: ./src/components/desktop/listing/pagination-wrapper-e6t/styles.module.scss
var pagination_wrapper_e6t_styles_module = __webpack_require__("L2oU");
var pagination_wrapper_e6t_styles_module_default = /*#__PURE__*/__webpack_require__.n(pagination_wrapper_e6t_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/pagination-wrapper-e6t/index.jsx
var pagination_wrapper_e6t_jsx = react_default.a.createElement;





var pagination_wrapper_e6t_PaginationWrapper = function PaginationWrapper(_ref) {
  var pagination = _ref.pagination,
      url = _ref.url,
      maximumPage = _ref.maximumPage,
      totalListingCount = _ref.totalListingCount,
      isAgentPage = _ref.isAgentPage,
      isProjectPage = _ref.isProjectPage,
      isShowcasePage = _ref.isShowcasePage;

  var _ref2 = pagination || {},
      page = _ref2.page,
      pageSize = _ref2.pageSize;

  var hasPageNumber = typeof page === 'number' && page > 0;
  var currentPagination = hasPageNumber ? page : 1;
  var defaultPageNumber = isAgentPage ? 28 : 30;
  var countOfListingsShowed = pageSize || defaultPageNumber;
  var maxPaginationCount = Object(helpers_url["e" /* getMaxPaginationCount */])({
    maximumPage: maximumPage,
    totalListingCount: totalListingCount,
    countOfListingShowed: countOfListingsShowed
  });
  var prevPaginationUrl = currentPagination > 1 && Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: currentPagination - 1,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var nextPaginationUrl = currentPagination !== maxPaginationCount && Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: currentPagination + 1,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var lastPaginationUrl = Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: maxPaginationCount,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var paginationList = Object(helpers_url["d" /* getLimitedPaginationList */])({
    maxPaginationCount: maxPaginationCount,
    currentPage: currentPagination,
    range: 5
  });
  var isFirstPage = currentPagination === 0;
  var firstPageNumberMultiplier = isFirstPage ? currentPagination : currentPagination - 1; // The range of the listings that are shown on the page. Eg 1-30, 31-60, 61-90. This param shows the initial index of the range.

  var shownListingsRangeInitialIndex = firstPageNumberMultiplier * countOfListingsShowed + 1;
  var isLastPage = currentPagination === maxPaginationCount;
  var shownListingsRangeLastIndex = shownListingsRangeInitialIndex + countOfListingsShowed - 1; // In case the listings are limited (for 30k listings we show max 1500 of them with 50 pages), the last index of the range will be the pageSize*50.

  var isListingsLimited = shownListingsRangeLastIndex < totalListingCount; // To ensure the the readibility of the code, we have created a function to get the last index of the range of the listings that are shown on the page and ignore code duplication.

  var getMaxShownListingsCount = function getMaxShownListingsCount() {
    if (!isLastPage) return shownListingsRangeLastIndex;
    if (isListingsLimited) return shownListingsRangeLastIndex;
    return totalListingCount;
  };

  var displayedListingsCountLastIndex = getMaxShownListingsCount();
  return pagination_wrapper_e6t_jsx(react_default.a.Fragment, null, paginationList.length > 1 && pagination_wrapper_e6t_jsx("div", {
    className: pagination_wrapper_e6t_styles_module_default.a.wrapper
  }, pagination_wrapper_e6t_jsx(pagination_e6t, {
    url: url,
    prev: prevPaginationUrl,
    next: nextPaginationUrl,
    totalPagination: {
      url: lastPaginationUrl,
      label: maxPaginationCount
    },
    defaultValue: {
      value: currentPagination,
      label: currentPagination
    },
    options: paginationList,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  }), pagination_wrapper_e6t_jsx("div", {
    className: pagination_wrapper_e6t_styles_module_default.a.subText
  }, "".concat(shownListingsRangeInitialIndex, " - ").concat(displayedListingsCountLastIndex, " aras\u0131ndaki ilanlar listeleniyor."))));
};

/* harmony default export */ var pagination_wrapper_e6t = __webpack_exports__["a"] = (pagination_wrapper_e6t_PaginationWrapper);

/***/ }),

/***/ "L2oU":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2wHxkP","subText":"_2c4dB7"};

/***/ }),

/***/ "LmzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("w/K5");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var style = {
  maxWidth: 1260,
  margin: '0px auto'
};

var Content = function Content(_ref) {
  var _classNames;

  var inline = _ref.inline,
      children = _ref.children,
      transparent = _ref.transparent,
      className = _ref.className;
  var mainClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.main, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.transparent, transparent), _classNames));
  var contentClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.content, true));
  return __jsx("div", {
    style: inline ? style : null,
    className: contentClass
  }, children);
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ "Oe3A":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"_3sBHLt","pageWrapperPlatinum":"gpY3jx","container":"_26o7D_","title":"_3y5dq3","suggestionBoxWrapper":"_2Wlb7I"};

/***/ }),

/***/ "TGiq":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"_2Tfd5Q","pagination":"_49yNIg"};

/***/ }),

/***/ "cA7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var styles = {
  badge: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '21px',
    letterSpacing: 'normal',
    textAlign: 'center',
    height: '20px',
    color: '#fff',
    borderRadius: 3,
    padding: '0 5px',
    marginBottom: 5,
    zIndex: 1
  }
};

var getBackgroundColor = function getBackgroundColor(type) {
  switch (type) {
    case 'new':
      return '#f16666';

    case 'promotion':
      return '#ffaa19';

    case 'opportunity':
      return '#58b847';

    case 'premium':
      return '#5f787e';

    case 'proje':
      return '#52ca46';

    case 'INSTALMENT':
      return '#ffffff';

    case 'DELAY':
      return '#ffffff';

    case 'DEPLETABLE':
      return '#ffffff';

    case 'ramadan':
      return "#7e56c6";

    case 'platinum':
      return "#2C394D";

    default:
      return null;
  }
};

var getBadgeName = function getBadgeName(type, data) {
  switch (type) {
    case 'new':
      return 'YENİ';

    case 'promotion':
      return 'ÖNE ÇIKAN';

    case 'opportunity':
      return 'JETFIRSAT';

    case 'premium':
      return 'PREMIUM';

    case 'proje':
      return 'PROJE';

    case 'INSTALMENT':
      return "".concat(data === null || data === void 0 ? void 0 : data.title, " AY TAKS\u0130T");

    case 'DELAY':
      return "".concat(data === null || data === void 0 ? void 0 : data.title, " AY VADE");

    case 'DEPLETABLE':
      return "T\xDCKENMEK \xDCZERE";

    case 'ramadan':
      return "RAMAZAN FIRSATI";

    case 'platinum':
      return "PLAT\u0130N";

    default:
      return null;
  }
};

var BadgeCardE6t = function BadgeCardE6t(props) {
  var _props$inline = props.inline,
      inline = _props$inline === void 0 ? true : _props$inline,
      style = props.style,
      type = props.type,
      data = props.data;
  var name = getBadgeName(type, data);
  if (!name) return null;
  var backgroundColor = getBackgroundColor(type);
  var campainClass = data && 'campain';
  var badgeStyle = inline ? _objectSpread(_objectSpread(_objectSpread({}, styles.badge), style), {}, {
    backgroundColor: backgroundColor
  }) : _objectSpread(_objectSpread({}, style), {}, {
    backgroundColor: backgroundColor
  });
  return __jsx("div", {
    className: campainClass,
    style: badgeStyle
  }, name);
};

/* harmony default export */ __webpack_exports__["a"] = (BadgeCardE6t);

/***/ }),

/***/ "fcgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateNewCriteria */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNewSuitableCriteria; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-plusplus */
var generateNewCriteria = function generateNewCriteria(criteria, trimmedFreeText, newCategory, newTradeType) {
  if (newCategory.length > 0 && newTradeType.length > 0) {
    var categoryTradeType = newTradeType[0].value.filter(function (tt) {
      return tt.categoryId === newCategory[0].id;
    });

    if (categoryTradeType.length > 0) {
      var newCriteria = {
        freetext: {
          value: trimmedFreeText
        },
        category: {
          category: newCategory[0],
          tradeType: {
            id: categoryTradeType[0].id,
            name: categoryTradeType[0].name,
            slug: categoryTradeType[0].slug
          },
          estateTypes: []
        }
      };

      if (typeof criteria.params.FROM_WHOM !== 'undefined' && criteria.params.FROM_WHOM === 'projects') {
        newCriteria.params = [{
          key: 'owner',
          value: {
            id: 'projeler',
            name: 'Proje firmasından'
          }
        }];
      }

      return newCriteria;
    }
  }

  return null;
};
var getNewSuitableCriteria = function getNewSuitableCriteria(criteria) {
  var _newCriteria$freetext;

  if (!criteria) return {};

  var newCriteria = _objectSpread({}, criteria);

  var _ref = newCriteria !== null && newCriteria !== void 0 ? newCriteria : {},
      location = _ref.location,
      order = _ref.order;

  var _ref2 = location !== null && location !== void 0 ? location : {},
      _ref2$poies = _ref2.poies,
      poies = _ref2$poies === void 0 ? undefined : _ref2$poies,
      city = _ref2.city; // delete empty freeText value


  if (!(newCriteria === null || newCriteria === void 0 ? void 0 : (_newCriteria$freetext = newCriteria.freetext) === null || _newCriteria$freetext === void 0 ? void 0 : _newCriteria$freetext.value)) {
    delete newCriteria.freetext;
  }

  if (city && !(city === null || city === void 0 ? void 0 : city.id)) {
    delete newCriteria.location.city;
  } // key name change --> poies to poiset and poies to poiList


  if (poies) {
    delete Object.assign(location, {
      poiSet: location.poies
    }).poies;

    for (var index = 0; index < location.poiSet.length; index++) {
      delete Object.assign(location.poiSet[index], {
        poiList: location.poiSet[index].poies
      }).poies;
    }
  } // key name change --> order to orderType


  if (order) {
    delete Object.assign(newCriteria.order, {
      orderType: newCriteria.order.orderType
    }).value;
  }

  return newCriteria;
};
/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ "mOBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Location = function Location(props) {
  if (props.format) {
    var location = props.format;
    ['city', 'district', 'town'].forEach(function (type) {
      location = location.replace("{".concat(type, "}"), props[type] && props[type].name || '');
    });

    if (location.trim().indexOf('/') === 0) {
      location = location.replace('/', '');
    }

    return __jsx("span", null, location);
  }

  return __jsx("span", null, props.district.name, " / ", props.town.name);
};

/* harmony default export */ __webpack_exports__["a"] = (Location);

/***/ }),

/***/ "w/K5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"_2-gYBG","transparent":"_5SI07-","content":"mrwLbC"};

/***/ })

}]);